import { useEffect, useState } from 'react';
import { dateSubmitFormat } from '../../../types/core/date.types';
import { format } from 'date-fns';
import { XCircleIcon } from '@heroicons/react/24/outline';

interface Props {
  name?: string;
  title?: string;
  placeholder?: string;
  handleChange: (value: Date | null) => void;
  value: Date | null;
  type: 'Date' | 'Datetime';
  isRequired?: boolean;
  className?: string;
  showClearButton?: boolean;
}

/**
 * General component for date | datetime input
 */
export const DateField = ({
  name,
  title,
  placeholder,
  handleChange,
  value,
  type = 'Date',
  isRequired,
  className,
  showClearButton = true,
  ...props
}: Props) => {
  const [date, setDate] = useState<string>(value ? format(new Date(value), dateSubmitFormat) : '');
  /**
   * Date changes - set local state and outside event
   * @param date
   */
  const onChange = (date: string) => {
    setDate(date);
    if (date === '') return handleChange(null);
    return handleChange(new Date(date));
  };

  useEffect(() => {
    setDate(value ? format(new Date(value), dateSubmitFormat) : '');
  }, [value]);

  return (
    <>
      <div className="relative">
        {title && <span>{title}</span>}
        <input
          name={name}
          className={`relative w-full border my-1 cursor-default rounded-lg bg-white py-2 pl-3 pr-2 text-left shadow-md focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-95 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm ${className}`}
          type={type}
          value={date}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          required={isRequired}
          {...props}
        />
        {showClearButton && date !== '' && (
          // TODO - lépe nastylovat - clear button není přesně na středu
          <XCircleIcon
            className={`cursor-pointer absolute ${
              title ? `top-[53%]` : `top-[30%]`
            } right-[25px] w-5 h-5 text-gray-400`}
            onClick={() => onChange('')}
          />
        )}
      </div>
    </>
  );
};
